import { useAppSelector } from "../../ReduxTool/store/hooks";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";

const Footer = () => {
  const { scale: {  meters, feet }, zoomlevel } = useAppSelector(state => state.mapref)
  // console.log("asfdasf asfasf     -->>   ",globalLayers?.latitude)
  return (
    <div className="hidden lg:grid lg:grid-cols-3 lg:gap-4 lg:items-center lg:w-full lg:px-2 lg:py-0.5">
      <ul className="flex flex-wrap gap-x-4 gap-2 max-lg:hidden">
        <li>
          <a href="https://terranxt.com/terms-and-conditions/" className="para-xs text-gray-600">
            Terms of Service
          </a>
        </li>
        <li>
          <a href="https://terranxt.com/privacy-policy/" className="para-xs text-gray-600">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href="https://terranxt.com/#contact" className="para-xs text-gray-600">
            Contact
          </a>
        </li>
      </ul>

      <p className="para-xs text-gray-600 max-lg:hidden text-center">
        © Terranxt Pvt Ltd. All rights reserved.
      </p>
      <ul className="flex gap-x-4 gap-y-2 flex-wrap max-lg:w-full max-lg:justify-between max-lg:text-xs justify-end">
        <li>
          <div  className="para-xs text-gray-600">
            Zoom: 
            <span id="zoomDiv">
            {Math.round(zoomlevel)}
          </span>          
          </div>
        </li>
        {/* <li>
          <div  className="para-xs text-gray-600">           
            Scale: {'  '}
            <span id="scale">
             {' '}{meters.toFixed(1)} m, {' '} {feet.toFixed(1)} f 
          </span>
          </div>
        </li> */}
        <li>
          <div  className="para-xs text-gray-600">
            Lat, Long: <span id="footer-lat">{globalLayers?.latitude?.toFixed(5) + ' "N'}</span>, <span id="footer-lng">{globalLayers?.longitude?.toFixed(5) + ' "E'}</span>
          </div>
        </li>
      </ul>
    </div>
  );
};
export default Footer;

// function GetCoordinates() {
//   return (
//     <div className="w-[18vh]">
//       Lat, Long:
//       <span id="footer-lat">{globalLayers?.latitude?.toFixed(5)}</span>, <span id="footer-lng">{globalLayers?.longitude?.toFixed(5)}</span>
//     </div>
//   );
// }
